export default function UserBenefits() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      gradient: 'from-purple-400 to-purple-600',
      title: '여성 인증 시스템',
      description: '안전한 커뮤니티 환경'
    },
    {
      icon: 'ri-map-pin-line',
      gradient: 'from-pink-400 to-pink-600',
      title: '지역별 맞춤 정보',
      description: '내 지역 알바만 모아보기'
    },
    {
      icon: 'ri-community-line',
      gradient: 'from-violet-400 to-violet-600',
      title: '실시간 커뮤니티',
      description: '생생한 후기와 정보 공유'
    },
    {
      icon: 'ri-time-line',
      gradient: 'from-fuchsia-400 to-fuchsia-600',
      title: '빠른 정보 확인',
      description: '한눈에 보는 공고 정보'
    },
    {
      icon: 'ri-search-line',
      gradient: 'from-purple-500 to-pink-500',
      title: '통합 검색',
      description: '커뮤니티 + 공고 동시 검색'
    },
    {
      icon: 'ri-notification-line',
      gradient: 'from-pink-500 to-purple-500',
      title: '알림 서비스',
      description: '새 공고 실시간 알림'
    }
  ];

  return (
    <section id="benefits" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-1.5 bg-purple-50 rounded-full">
            <span className="text-sm text-purple-700 font-medium">핵심 혜택</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            온니잡만의 특별한 장점
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            여성들을 위해 특별히 설계된 안전하고 편리한 플랫폼
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100 hover:border-purple-200 hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 bg-gradient-to-br ${benefit.gradient} rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                <i className={`${benefit.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}